import { BrowserRouter, Routes, Route } from 'react-router';

import { ScrollToTop } from '@components/ScrollToTop';
import { MenuProvider } from '@/contexts/MenuContext';
import { PageTransitionProvider } from '@/contexts/PageTransitionContext';
import { AffixProvider } from '@/contexts/AffixContext';
import UsaPageContainer from '@pages/Usa/UsaContainer.tsx';

export function App() {
  return (
    <MenuProvider>
      <AffixProvider>
        <BrowserRouter>
          <ScrollToTop />
          <PageTransitionProvider>
            <Routes>
              <Route
                path="/usa"
                element={<UsaPageContainer />}
              />
            </Routes>
          </PageTransitionProvider>
        </BrowserRouter>
      </AffixProvider>
    </MenuProvider>
  );
}
